<template>
  <div class="dashboardAdvertiser">
    <template v-if="!isLoading">
      <!-- <div class="dashboardAdvertiser__title">
        <h2 class="medium-title">All Campaign</h2>
      </div> -->
      <div class="dashboardAdvertiser__header">
        <div class="dashboardAdvertiser__header__search">
          <span class="icon"><i class="adx-ic_search"></i></span>
          <input v-model="searchText" type="text" class="search subhead" placeholder="Search campaign name">
        </div>
        <adx-dropdown @selected="selectStatus" :list="listStatus" :labelButton="selectedLabel?selectedLabel:'All status'"  />
      </div>
      <div class="dashboardAdvertiser__body">
        <table class="table-campaign">
          <thead class="header">
            <th class="header__status">Status</th>
            <th class="header__campaign">Campaign</th>
            <th class="header__period">Period</th>
            <th class="header__reach">Est.Reach</th>
            <th class="header__cost">Total Cost</th>
            <th class="header__action"></th>
          </thead>
          <tbody>
            <tr v-if="!loadingData && campaigns.length == 0">
              <td colspan="6">
                <adx-empty />
              </td>
            </tr>
            <tr v-else-if="!loadingData && campaigns.length > 0" v-for="campaign in campaigns" :key="campaign.id">
              <td :class="[getStatusClass(campaign.status), 'strong']">{{ displayStatus(campaign.status) }}</td>
              <td>
                <p class="subhead strong campaign-title">{{ campaign.title }}</p>
                <span>{{ campaign.total_item }} items</span>
              </td>
              <td>
                <span>{{ displayPeriod(campaign.start, campaign.end) }}</span>
              </td>
              <td class="est-reach">{{ campaign.reach | formatNumber}}</td>
              <td>{{ campaign.net_price | formatMoney }}</td>
              <td class="action">
                <tooltip text="View Detail">
                  <span slot="content" >
                    <i class="icon-eye" @click.stop="goToDetail(campaign.id)" ></i>
                  </span>
                </tooltip>
                <tooltip text="View Report">
                  <span slot="content" >
                    <button class="icon-file-copy" v-if="campaign.campaign_report_id != 0" @click.stop="goToReport(campaign.id)" ></button>
                  </span>
                </tooltip>
                <tooltip text="View Contents">		
                  <span slot="content" >		
                    <i class="icon-image" @click.stop="goToContents(campaign.id)" ></i>		
                  </span>		
                </tooltip>             
              </td>
            </tr>
            <tr v-else>
              <td colspan="6">
                <adx-loading  />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="!loadingData && campaigns.length > 0" class="dashboardAdvertiser__footer">
        <adx-pagination 
          @change-page="selectPage" 
          :maxPage="maxPage" 
          :selectedPage="selectedPage" />
      </div>
    </template>
    <div v-else class="dashboardAdvertiser__loading">
      <adx-loading />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Input from '@/components/Form/Input'
import Dropdown from '@/components/Dropdown/ListDropdown'
import Empty from '@/components/NotFound/Selection'
import Pagination from '@/components/Pagination'
import Loading from '@/components/Loading/Primary'
import Tooltip from '@/components/Tooltip'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'
import { helpers } from '@/lib/validation/'

export default {
  name: 'adx-dashboard-advertiser',
  components: {
    'adx-input': Input,
    'adx-dropdown': Dropdown,
    'adx-empty': Empty,
    'adx-pagination': Pagination,
    'adx-loading': Loading,
    'tooltip': Tooltip
  },
  props: {

  },
  data() {
    return {
      // active: false,
      listStatus: [
        {
          id: 1,
          label: 'All status',
          value: ''
        },
        {
          id: 2,
          label: 'Waiting approval',
          value: 'wfa'
        },
        {
          id: 3,
          label: 'Upcoming',
          value: 'upcoming'
        },
        {
          id: 4,
          label: 'Active',
          value: 'active'
        },
        {
          id: 5,
          label: 'Expired',
          value: 'expired'
        },
        {
          id: 6,
          label: 'Canceled',
          value: 'canceled'
        },
        {
          id: 7,
          label: 'Disapproved',
          value: 'rejected'
        },
      ],
      campaigns: [],
      filteredCampaigns: [],
      selectedStatus: '',
      selectedLabel: 'All status',
      searchText: '',
      selectedPage: 1,
      maxPage: 1,
      isLoading: false,
      loadingData: false,
    }
  },
  computed: {
    
  },
  watch: {
    searchText: helpers.debounce(function () {
      this.$nextTick(function () {
        this.getCampaigns()
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {
    let query = this.$route.query
    if (query.page) {
      this.selectedPage = query.page
    } else if (query.search) {
      this.searchText = query.search
    } else if (query.status) {
      this.selectedStatus = query.status
    }
  },
  beforeMount() {
    this.isLoading = true
    this.getCampaigns()
    this.isLoading = false
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getCampaigns() {
      (async () => {
        this.loadingData = true
        let param = {page: this.selectedPage}
        if (this.selectedStatus) {
          param.status = this.selectedStatus
        }
        if (this.searchText) {
          param.search = this.searchText
        }
        let response = await api.get(apiV2.myCampaigns, {needToken: true, params: param})
        if (response.status == 200) {
          this.campaigns = response.data.results
          this.maxPage = response.data.max_page
          this.loadingData = false
        } else {

        }
      })();
    },
    selectStatus(item) {
      this.selectedStatus = item.value
      this.selectedLabel = item.label
      this.getCampaigns()
    },
    selectPage(page) {
      this.selectedPage = page
      this.getCampaigns()
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    },
    displayStatus(status) {
      return lib.displayCampaignStatus(status)
    },
    isEmpty() {
      if (this.campaigns.length == 0) {
        return true
      }

      return false
    },
    goToDetail(campaignId) {
      this.$router.push({ name: 'campaigndetail', params: { id: campaignId }})
    },
    goToReport(campaignId) {
      this.$router.push({ name: 'campaignreportv2', params: { campaign_id: campaignId }})
    },
    goToContents(campaignId){		
      this.$router.push({ name: 'campaigncontents', params: { id: campaignId }})		
    },	
    getStatusClass(status) {
      status = status.toLowerCase()
      if (status == 'waiting for approval') {
        return 'wfa'
      } else if (status == 'waiting for payment') {
        return 'wfp'
      } else if (status == 'active') {
        return 'active'
      } else if (status == 'upcoming') {
        return 'upcoming'
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.advertiser {
  .menu {
    width: 180px;
  }

  .dropdown {
    &__menu {
      min-width: 180px;
    }
  }
}

.dashboardAdvertiser {
  .emptySelection {
    margin-top: 120px;
  }
}
</style>
